import React from 'react';
import { useStateSelector } from 'src/redux';
import { ColorSet } from 'src/redux/reducers/theme';
import styled from 'styled-components';

const Svg = styled.svg<{ $cursorDefault?: boolean }>`
  cursor: ${({ $cursorDefault }) => ($cursorDefault ? 'default' : 'pointer')};
  outline: none !important;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 16px;
    height: 16px;
  }
  ${({ theme }) => theme.breakpoints.down('sm')} {
    width: 14px;
    height: 14px;
  }
`;

interface Props {
  tooltipId?: string;
  cursorDefault?: boolean;
  color?: keyof ColorSet;
  style?: React.CSSProperties;
}

export const InfoIcon: React.FC<Props> = ({ tooltipId = '', cursorDefault, color = 'cflowerBlue', style }) => {
  const colors = useStateSelector(({ theme }) => theme.colors);
  return (
    <Svg
      data-tooltip-id={tooltipId}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      $cursorDefault={cursorDefault}
      style={style}
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z"
        fill={colors[color]}
      />
    </Svg>
  );
};
